module.exports = {
          srcSet: __webpack_public_path__ + "3f30413a823dd2d441bdb5b9acd80519-926.jpg"+" 926w",
          images:[ {path: __webpack_public_path__ + "3f30413a823dd2d441bdb5b9acd80519-926.jpg",width: 926,height: 560}],
          src: __webpack_public_path__ + "3f30413a823dd2d441bdb5b9acd80519-926.jpg",
          toString:function(){return __webpack_public_path__ + "3f30413a823dd2d441bdb5b9acd80519-926.jpg"},
          
          width: 926,
          height: 560
        }